import React from 'react';
import { Theme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';

const useStyles = makeStyles()((theme: Theme) => ({
  box: {
    backgroundColor: 'white',
    maxWidth: '650px',
    marginLeft: 'auto',
    marginRight: 'auto',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    width: '90%',
  },
  highlight: {
    paddingTop: theme.spacing(2),
    color: theme.palette.primary.main,
  },
}));

export const ErrorNoAuthUser = ({
  error,
  resetError,
}: {
  error: Error;
  resetError: () => void;
}) => {
  return <ErrorNoAuthUserComponent error={error} resetError={resetError} />;
};

const ErrorNoAuthUserComponent = ({
  error,
  resetError,
}: {
  error: Error;
  resetError: () => void;
}) => {
  const { classes } = useStyles();

  const handleReset = () => {
    resetError();
  };

  return (
    <Box className={classes.box}>
      <p>
        {typeof error === 'string'
          ? error
          : error.message
          ? error.message
          : 'Unknown error'}
      </p>

      <Button variant="contained" color="primary" onClick={handleReset}>
        Try again
      </Button>
      <p>
        Contact{' '}
        {<span className={classes.highlight}>support@gekkovet.com</span>} if
        needed.
      </p>
    </Box>
  );
};
